<template>
  <div class="CustomerDetails">
    <v-row class="header d-flex flex-column flex-sm-row align-center">
      <v-col class="align-center col-12 col-sm-5 col-md-3 d-flex">
        <v-btn
          icon
          class="theme-btn app-button-primary-light color nice-padding"
          @click.stop="navigateTo('UsersList')"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <div class="user ml-4">
          <div class="name">{{ profileLabel }}</div>
          <div class="id">#{{ currentCustomerFile.amundi_client_reference }}</div>
        </div>
      </v-col>
      <v-col class="col-12 col-sm-7 col-md-5 col-lg-5 col-xl-3 d-flex align-center ">
        <Tabs
          v-if="tabsNames.length > 1"
          v-model="activeTab"
          class="mx-0"
          :tabs="tabsNames"
        />
      </v-col>
      <v-col class="justify-center d-flex">
        <Indicators
          v-if="Object.keys(currentCustomerFile).length"
          :risk="+currentCustomerFile.risk_score"
          :revivals="+currentCustomerFile.reminders_sent"
          :status="currentCustomerFile.status"
        />
      </v-col>
    </v-row>
    <div class="content">
      <ActivityLog v-if="activeTab === 0" />
      <CustomerData v-if="activeTab === 1" />
      <CustomerFiles v-if="activeTab === 2" />
    </div>
  </div>
</template>

<script>
  import Tabs from '@/components/ui/common/Tabs/Tabs'
  import CommonMixin from '@/mixins/store/CommonMixin'
  import AdminMixin from '@/mixins/store/AdminMixin'
  import ActivityLog from '@/pages/CRM/CustomerDetails/components/ActivityLog'
  import CustomerData from '@/pages/CRM/CustomerDetails/components/CustomerData'
  import CustomerFiles from '@/pages/CRM/CustomerDetails/components/CustomerFiles'
  import Indicators from '@/pages/CRM/CustomerDetails/components/Indicators'

  export default {
    components: {
      Tabs,
      ActivityLog,
      CustomerData,
      CustomerFiles,
      Indicators,
    },
    mixins: [CommonMixin, AdminMixin,],
    data() {
      return {
        activeTab: 0,
        tabsNames: [
          this.$t('crm.userList.logs'),
          this.$t('crm.userList.data'),
          this.$t('crm.userList.supporting_documents'),
        ],
      }
    },
    computed: {
      profileLabel() {
        if (this.currentCustomer.first_name && this.currentCustomer.last_name) {
          return `${this.currentCustomer.first_name} ${this.currentCustomer.last_name}`
        } else {
          return this.$t('common.not_specified')
        }
      },
    },
    async mounted() {
      await this.refreshCustomerFields()
    },
  }
</script>

<style scoped lang="scss">
.CustomerDetails {
  height: 100%;
  padding-top: 20px;
  .header {
    padding: 1.5rem 2.5rem;
    background-color: $color-ffffff;
    box-shadow: 0 4px 8px 0 rgba(31, 54, 139, 0.08);
    .user {
      font-size: 0.9rem;
      .name {
        color: $color-009ee0;
      }
      .id {
        color: $color-00c3f1;
      }
    }
  }
  .content {
    margin: 2.5rem;
    padding: 2rem;
    box-shadow: 0 4px 8px 0 rgba(31, 54, 139, 0.08);
    border-radius: 8px;
    background-color: $color-ffffff;
  }
}
</style>
